module.exports = __webpack_public_path__ + "static/media/cartola.b7ae1879.svg";